// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__gt5aw","icon":"Logo_icon__aveEe"};